import { useTranslation } from 'react-i18next'
import editbtn from 'assets/images/editPersonal.png'
import {
  StyledBottomPart,
  StyledDetailedSubTitle,
  StyledDetails,
  StyledDetailsContent,
  StyledDetailsMainTitle,
  StyledEditBtn,
  StyledMiniTitle,
  StyledPersonalDetailsContainer,
  StyledTopPart,
} from './styles'
import { IPersonalDetails } from 'types/interfaces/IPersonalDetails'
import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from 'store/store'
import { PersonalDetailsModal } from './components/personalDetailsModal/PersonalDetailsModal'

import moment from 'moment'
import { FavPlayerImage } from './components/playerImage/FavPlayerImage'
import { useUpdateSfUserMutation } from 'store/api-slices/userSlice'
import { updateUserPersonalDetails } from 'store/reducers/userReducer'

export interface IUserDetailsProps {
  userDetails?: IPersonalDetails
}

export function PersonalDetails() {
  const { t } = useTranslation('', {
    keyPrefix: 'pages.personalArea.tabs.personalDetails',
  })
  const [isEditModalOpen, setIsEditModalOpen] = useState(false)
  const userDetails = useAppSelector((state) => state.user).personalDetails
  const [editUserDetails, setEditUserDetails] = useState<IPersonalDetails>({
    firstName: userDetails?.firstName ?? '',
    lastName: userDetails?.lastName ?? '',
    dob: userDetails?.dob ?? '',
    playerImage: userDetails?.playerImage ?? 0,
    addresses: [
      {
        street: userDetails?.addresses?.[0]?.street ?? '',
        buildingNumber: userDetails?.addresses?.[0]?.buildingNumber ?? '',
        city: userDetails?.addresses?.[0]?.city ?? '',
      },
    ],
  })

  useEffect(() => {
    if (userDetails) {
      setEditUserDetails({
        firstName: userDetails?.firstName ?? '',
        lastName: userDetails?.lastName ?? '',
        dob: userDetails?.dob ?? '',
        playerImage: userDetails?.playerImage ?? 0,
        addresses: [
          {
            street: userDetails?.addresses?.[0]?.street ?? '',
            buildingNumber: userDetails?.addresses?.[0]?.buildingNumber ?? '',
            city: userDetails?.addresses?.[0]?.city ?? '',
          },
        ],
      })
    }
  }, [userDetails])

  const handleEditClick = () => {
    setIsEditModalOpen(true)
  }

  const handleModalClose = () => {
    setIsEditModalOpen(false)
  }

  const dispatch = useAppDispatch()
  const [updateSfUser] = useUpdateSfUserMutation()

  return (
    <StyledPersonalDetailsContainer>
      <StyledTopPart>
        <StyledDetailsMainTitle>{t('text')}</StyledDetailsMainTitle>
        <StyledEditBtn onClick={handleEditClick}>
          <img src={editbtn} alt="edit-info" />
        </StyledEditBtn>
      </StyledTopPart>
      <StyledBottomPart>
        <FavPlayerImage
          userDetails={editUserDetails}
          onChange={async (playerImage: number) => {
            try {
              await updateSfUser({ playerImage }).unwrap()
              dispatch(
                updateUserPersonalDetails({
                  playerImage,
                }),
              )
            } catch (err) {
              console.log({ err })
            }
          }}
        />
        <StyledDetails>
          <StyledDetailsContent>
            <StyledMiniTitle>{t('details.firstName')}</StyledMiniTitle>
            <StyledDetailedSubTitle>
              {userDetails?.firstName}
            </StyledDetailedSubTitle>
          </StyledDetailsContent>
          <StyledDetailsContent>
            <StyledMiniTitle>{t('details.lastName')}</StyledMiniTitle>
            <StyledDetailedSubTitle>
              {userDetails?.lastName}
            </StyledDetailedSubTitle>
          </StyledDetailsContent>
          <StyledDetailsContent>
            <StyledMiniTitle>{t('details.dob')}</StyledMiniTitle>
            <StyledDetailedSubTitle>
              {(editUserDetails?.dob &&
                moment(new Date(editUserDetails.dob)).format('DD.MM.YYYY')) ??
                ''}
            </StyledDetailedSubTitle>
          </StyledDetailsContent>
          <StyledDetailsContent>
            <StyledMiniTitle>{t('details.address')}</StyledMiniTitle>
            <StyledDetailedSubTitle>
              {userDetails?.addresses && userDetails.addresses.length > 0
                ? `${userDetails.addresses[0].street} ${userDetails.addresses[0].buildingNumber}, ${userDetails.addresses[0].city}`
                : null}
            </StyledDetailedSubTitle>
          </StyledDetailsContent>
        </StyledDetails>
      </StyledBottomPart>

      <PersonalDetailsModal
        isOpen={isEditModalOpen}
        userDetails={editUserDetails}
        onClose={handleModalClose}
      />
    </StyledPersonalDetailsContainer>
  )
}
